import React from 'react';
import { isEmpty } from 'lodash';
import {
  erroMessageView as ErroMessageView,
  loaderView as LoaderView,
  footerView as FooterView
} from '../../shared/index';
import xtforge_xebia from '../../assets/images/xtforge_xebia.png';

export const loginView = (props) => {
  const { email, password, onChange, onSubmit, errorMessage, isLoading } =
    props;
  const _bothFieldBlank = isEmpty(email) || isEmpty(password);
  return (
    <>
    <div className='login__container'>
      {/* <div className='container mt-4'> */}
        <div className='row justify-content'>
          <div className='loginright__container'>
            <h2 className='text-center mb-4 logo-image'>
              {/* XTForge Login */}
              <img src={xtforge_xebia} alt='logo' className='logo__link__img' />
              {/* <span className='first-letter'>X</span>ebia */}
            </h2>
            <form onSubmit={onSubmit}>
              <div className='forms-inputs mb-4'>
                <label htmlFor='email' className='form-label'>
                  Username:
                </label>
                <input
                  type='text'
                  className='form-control'
                  id='email'
                  required='required'
                  name='email'
                  value={email}
                  onChange={onChange}
                  placeholder='Enter your username'
                />
              </div>
              <div className='forms-inputs mb-4'>
                <label htmlFor='password' className='form-label'>
                  Password:
                </label>
                <input
                  type='password'
                  className='form-control'
                  id='password'
                  name='password'
                  value={password}
                  onChange={onChange}
                  placeholder='Enter your password'
                  required='required'
                />
              </div>
              {isEmpty(errorMessage) ? null : (
                <ErroMessageView className='danger' data={errorMessage} />
              )}
              <div className='login__button-wrapper'>
                {isLoading ? (
                  <button
                    type='button'
                    className='btn btn-login'
                  >
                    <LoaderView />
                    &nbsp;
                  </button>
                ) : (
                  <button
                    type='submit'
                    className={`btn btn-login ${
                      _bothFieldBlank ? 'btn--disable' : ''
                    }`}
                    disabled={_bothFieldBlank}
                  >
                    Login
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      {/* </div> */}
        <FooterView />
    </div>
        </>
  );
};
